import React, { Component } from 'react'

// ui
import Modal from '../../components/feedback/modal'
import Button from '../../components/uielements/button'

// redux
import { connect } from 'react-redux'
import eventActions from '../../redux/event/actions'

class RemoveEvent extends Component {
    _handleOK = () => {
        this.props.dismiss()
        this.props.removeEvent(this.props.idRemove)
    }

    _handleCancel = () => {
        this.props.dismiss()
    }

    render() {
        const { visible } = this.props
        return (
            <Modal
                visible={visible}
                title="Xác nhận xoá sự kiện"
                onOk={() => this._handleOK()}
                onCancel={() => this._handleCancel()}
                centered
                footer={[
                    <Button
                        key="back"
                        size="large"
                        type="primary"
                        onClick={() => this._handleCancel()}
                    >
                        Huỷ
                    </Button>,
                    <Button
                        key="submit"
                        size="large"
                        type="danger"
                        onClick={() => this._handleOK()}
                    >
                        Xoá
                    </Button>,
                ]}
            >
                <p>Bạn có chắc chắn muốn xoá sự kiện này?</p>
            </Modal>
        )
    }
}

const mapStateToProps = state => {
    return {
        visible: state.eventReducer.visibleRemoveModal,
        idRemove: state.eventReducer.idRemove,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dismiss: () => {
            dispatch(eventActions.action.visibleRemoveModal(false))
        },
        removeEvent: eid => {
            dispatch(eventActions.action.deleteEventById(eid))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RemoveEvent)
